/**
 * @file src/components/organisms/ReturnBarDial/ReturnBarDial.tsx
 * @description This file defines the ReturnBarDial component for displaying return scores with a dial.
 * @module ReturnBarDial
 */

import React, { FC } from 'react';
import { ListItem } from '@/components';
import BarDial from '@/components/atoms/BarDial/BarDial';
import { YieldBearingAssetInterface } from '@/interfaces';

interface ReturnBarDialProps {
  asset: YieldBearingAssetInterface;
  mode?: 'leftHalf' | 'rightHalf' | 'full';
  width?: string;
  height?: string;
}

const ReturnBarDial: FC<ReturnBarDialProps> = ({
  asset,
  mode = 'full',
  width = 'w-24',
  height = 'h-4',
}) => {
  const getReturnTypeColor = (
    score: number | undefined,
  ):
    | 'error'
    | 'primary'
    | 'accent'
    | 'secondary'
    | 'warning'
    | 'disabled'
    | null
    | undefined => {
    switch (score) {
      case 0:
      case 1:
        return 'error';
      case 2:
        return 'primary';
      case 3:
      case 4:
        return 'accent';
      default:
        return null;
    }
  };

  const returnTypeColor = getReturnTypeColor(asset.returnScore);

  return (
    <BarDial
      value={asset.returnScore ? (asset.returnScore / 4) * 100 : 0}
      mode={mode}
      fillColor="bg-accent"
      width={width}
      height={height}
      showBreakpoints={true}
      hoverContent={
        <div className="flex flex-col items-start">
          <ListItem
            mainText={asset.returnScore ? `${asset.returnType}` : 'Unknown'}
            mainTextColor={returnTypeColor}
            subSubText={'Return Profile'}
          />
        </div>
      }
    />
  );
};

export default ReturnBarDial;
